import { NgModule } from '@angular/core';
import { provideNavConfig } from '@capital-access/common/navigation';
import { CommonRouterModule } from '@capital-access/common/router';
import { CAIntelligenceNavConfigProvider } from './ca-intelligence-nav-config.provider';
import { getFeatureEnabledGuard } from './ca-intelligence-navigation-guards';
import { CA_INTELLIGENCE_PATH, CA_INTELLIGENCE_FEATURE_TOGGLE } from './constants';

const loadMermaid = async (): Promise<void> => {
  if (typeof window === 'undefined') {
    return;
  }

  const windowWithMermaid = window as Window & { mermaid?: unknown };
  if (!windowWithMermaid.mermaid) {
    const mermaidModule = await import('mermaid');
    windowWithMermaid.mermaid = mermaidModule.default;
  }
};

export const loadModule = async () => {
  await loadMermaid();
  const module = await import('@capital-access/ca-intelligence/client');
  return module.CAIntelligenceClientModule;
};
@NgModule({
  imports: [
    CommonRouterModule.forFeature({
      authorized: [
        {
          path: CA_INTELLIGENCE_PATH,
          canActivate: [getFeatureEnabledGuard(CA_INTELLIGENCE_FEATURE_TOGGLE)],
          loadChildren: loadModule
        }
      ]
    })
  ],
  providers: [provideNavConfig(CAIntelligenceNavConfigProvider)]
})
export class CAIntelligenceLazyModule {}
